import { ButtonProps } from '@designsystem/stories/02-atoms/Button';
import { ButtonGroup } from '@designsystem/stories/03-molecules/ButtonGroup';
import { normalizeContent } from '@fhnw/helpers/DesignSystem/normalizeContent';

export interface BlockDataProps {
  items?: ButtonProps[];
}

export interface ViewProps {
  data: BlockDataProps;
  isEdit?: boolean;
}

const View = (props: ViewProps) => {
  const { data } = props;

  if (!data?.items || data?.items.length === 0) {
    return null;
  }

  return (
    <p>
      <ButtonGroup
        spaced
        items={normalizeContent(data?.items, true) as ButtonProps[]}
      />
    </p>
  );
};

export default View;
